module.exports = __webpack_public_path__ + "media/images/icon/icon-instagram-9ab1a07ab1d99da8d3e04053a0cac0a6.svg";